import PropTypes from 'prop-types';
import { memo } from 'react';
import { twMerge } from 'tailwind-merge';

import Button from 'shopper/components/Button';
import Heading from 'shopper/components/Heading';
import Icon from 'shopper/components/Icon';

import Image from 'components/Image';

import { sendEvent } from 'lib/gtag';
import { toStoreImageAltText } from 'lib/image';
import placeholder from 'lib/placeholder';

import APP from 'constants/app';

const onButtonClick = (gaEventCategory) => {
  sendEvent({ category: gaEventCategory, action: 'go_store' });
};

const StoreItem = ({
  className,
  gaEventCategory,
  icon,
  title,
  url,
  ...rest
}) => (
  <div
    className={twMerge(
      'flex flex-col items-center justify-start pb-6 pt-4',
      className
    )}
    {...rest}
  >
    <div className="flex size-18 items-center justify-center rounded-full bg-neutral-high-200 dark:bg-neutral-low-200 md:size-24">
      <Image
        alt={toStoreImageAltText(title)}
        className="md:size-24"
        height={72}
        src={`${APP.LOCAL_IMAGE_PATH}/features/search-results/stores/${icon}.png`}
        width={72}
        aria-hidden
      />
    </div>
    <Heading as="h2" className="mt-4 text-center" size="size6">
      {title}
    </Heading>
    <Button
      as="a"
      className="mt-2"
      href={url}
      iconRight={<Icon name="link-blank" />}
      rel="noreferrer"
      size="size2"
      target="_blank"
      type="secondary"
      onClick={() => onButtonClick(gaEventCategory)}
    >
      {placeholder('actions.access')}
    </Button>
  </div>
);

StoreItem.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  gaEventCategory: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default memo(StoreItem);
